export const PartnerStatus = {
  Onboarding: 'Onboarding',
  Active: 'Active',
} as const;

export type PartnerStatus = (typeof PartnerStatus)[keyof typeof PartnerStatus];

export class Partner {
  name: string;
  status: PartnerStatus;

  constructor(name: string = '-', status: PartnerStatus = PartnerStatus.Onboarding) {
    this.name = name;
    this.status = status;
  }

  get isActive(): boolean {
    return this.status === PartnerStatus.Active;
  }
}
